import { useMediaQuery } from 'react-responsive';

export const useViewport = () => {
    const isMobile = useMediaQuery({ maxWidth: 900 })
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
    const isDesktop = useMediaQuery({ minWidth: 992 })
    return { isMobile, isDesktop, isTablet };
}